import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

export type EfContextUsageIndicatorProps = {
    used: number;
    limit: number;
    label: string;
};

const formatTokens = (value: number): string => {
    if (value >= 1000) {
        return `${(value / 1000).toFixed(value >= 10000 ? 0 : 1)}k`;
    }
    return `${value}`;
};

export function EfContextUsageIndicator({ used, limit, label }: EfContextUsageIndicatorProps) {
    const ratio = limit > 0 ? Math.min(used / limit, 1) : 0;
    const percent = Math.round(ratio * 100);
    const color = ratio >= 0.9 ? 'error' : ratio >= 0.75 ? 'warning' : 'primary';

    return (
        <Tooltip title={`${label}: ${formatTokens(used)} / ${formatTokens(limit)} tokens (${percent}%)`}>
            <Box data-testid="ef-context-usage" sx={{ position: 'relative', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <CircularProgress variant="determinate" value={100} size={26} thickness={4} sx={{ color: 'action.disabledBackground' }} />
                <CircularProgress variant="determinate" value={percent} size={26} thickness={4} color={color} sx={{ position: 'absolute', left: 0 }} />
                <Box sx={{ position: 'absolute', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Typography sx={{ fontSize: 8, fontWeight: 600, color: 'text.secondary', lineHeight: 1 }}>{percent}</Typography>
                </Box>
            </Box>
        </Tooltip>
    );
}
